// eslint-disable-next-line import/no-extraneous-dependencies
import * as RadixDropdown from "@radix-ui/react-dropdown-menu";
import { styled } from "@vitality-ds/system";
import contentStyles from "./styles/Content.styles";
import triggerStyles from "./styles/Trigger.styles";
export var BaseDropdown = styled(RadixDropdown.Root);
export var Trigger = styled(RadixDropdown.Trigger, triggerStyles);
export var Content = styled(RadixDropdown.Content, contentStyles);